import * as AssetRepository from './Repositories/AssetRepositoryAsync';
import { ActiveProfile, ActiveLanguageId } from './Config/ActiveProfile';
import { LanguageMapper } from './Mappers/LanguageMapper';

type Language = { [name: string]: string };
type Languages = { [name: string]: Language};

class ContentService {
  private static readonly _languages: Languages = {};

  public static GetLanguage(languageKey?: string): Language {
    return this._languages[languageKey];
  }

  public static async PrefetchAllLanguages(): Promise<void> {
    const supportedLanguages = ActiveProfile.SupportedLanguages;
    const defaultLanguageId = ActiveProfile.DefaultLanguage;

    const additionalLanguageRequests = Object.keys(supportedLanguages)
      .filter((key) => key !== defaultLanguageId)
      .map((key) => {
        return {
          key: key,
          value: this.FetchLanguage(key),
        };
      });

    await Promise.all(additionalLanguageRequests.map((language) => language.value));
  }

  public static async FetchActiveLanguage(): Promise<void> {
    await ContentService.FetchLanguage(ActiveLanguageId);
  }

  private static async FetchLanguage(languageKey: string): Promise<void> {
    const localLang = AssetRepository.GetLanguage(languageKey);
    const iabLang = AssetRepository.GetIabLanguage(languageKey);

    const [localString, iabString] = await Promise.all([localLang, iabLang]);
    const combinedLang: Language = LanguageMapper.map(localString, iabString);

    this._languages[languageKey] = combinedLang;
  }
}
export { ContentService };